<template>
  <!-- <div class="col-xl-8" id="measurement"> -->
  <div id="measurement">
    <div class="portlet">
      <div class="portlet-head portlet-head-tab">
        <h3>Pomiary</h3>
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" v-for="(item, index) in tabs" :key="index">
            <a
              :class="{'nav-link':true, 'nav-basic': true, 'active': item.isActive}"
              :id="item.id"
              v-on:click="showTab(item)"
            >{{item.name}}</a>
          </li>
        </ul>
      </div>
      <div class="portlet-body">
        <div class="mytab-content" id="nav-tabContent">
          <div :class="{'mytab-pane':true,'active':tabs[0].isActive}">
            <MeasurementRooms :rooms="measurement.rooms" :height="measurement.height" />
          </div>
          <div :class="{'mytab-pane':true,'active':tabs[1].isActive}">
            <MeasurementTiles :tiles="measurement.tiles" />
          </div>
          <div :class="{'mytab-pane':true, 'active':tabs[2].isActive}">
            <MeasurementItems :items="measurement.items" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import MeasurementRooms from "@/components/measurement/MeasurementRooms";
import MeasurementTiles from "@/components/measurement/MeasurementTiles";
import MeasurementItems from "@/components/measurement/MeasurementItems";

export default {
  name: "MeasurementPortlet",
  components: {
    MeasurementRooms,
    MeasurementTiles,
    MeasurementItems
  },
  props: {
    measurement: {
      type: Object
    }
  },
  data() {
    return {
      tabs: [
        { name: "Pomieszczenia", id: "rooms-tab", isActive: true },
        { name: "Kafelki", id: "tiles-tab", isActive: false },
        { name: "Drzwi i okna", id: "doors-tab", isActive: false }
      ],
      activeTab: {}
    };
  },
  computed: {},
  created() {
    this.activeTab = this.tabs[0];
  },
  methods: {
    showTab(tab) {
      if (this.activeTab) {
        this.activeTab.isActive = false;
      }
      tab.isActive = true;
      this.activeTab = tab;
    }
  }
};
</script>